import axios from 'axios';
import ClassenService from '../ClassenService';

class UserService {
  loginUser(data) {
    return ClassenService.doApiCall('post', 'oauth/token', 'loginUser', data);
  }

  getUsers() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/users`);
  }

  addUser(userData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/users`, 'addUser', userData);
  }

  getUser(userId = null) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/users/${userId || 'current'}`, 'getUser');
  }

  updateUser(userId, userData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/users/${userId}`, 'updateUser', userData);
  }

  changePassword(userId, userData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/users/${userId}/password`, 'changePassword', userData);
  }

  updateOwnUser(userId, userData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/users/${userId}/self`, 'updateOwnUser', userData);
  }

  deleteUser(userId, changeToId) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/users/${userId}/delete`, 'deleteUser', {userId: changeToId});
  }

  getNewUsers() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}new/users/`);
  }

  addNewUser(newUserData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/new/users`, 'addNewUser', newUserData);
  }

  getNewUser(token) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/new/users/${token}`);
  }

  updateNewUser(token, newUserData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/new/users/${token}`, 'updateNewUser', newUserData);
  }

  deleteNewUser(token) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/new/users/${token}`, 'deleteNewUser');
  }

  setToken(authToken) {
    axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
    return this;
  }

  setLanguage(lang) {
    axios.defaults.headers.common['Content-Language'] = lang;
    return this;
  }

  setLoggedInAtProperty() {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/users/login`);
  }
}

export default new UserService();
